<template>
  <v-container>
    <div id="grid-productos">
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Gestión de {{ nombrePestana }}</v-toolbar-title
        >
        <v-btn
          v-if="muestraAdministracion && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
          color="primary"
          @click="crearSuperProducto()"
        >
          Agregar
        </v-btn>
      </v-toolbar>

      <!--  dsoto 03-11-2022 -->
      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-text-field
            onkeydown="return event.key != 'Enter';"
            action="." 
            method="get"
            v-model="search"
            append-icon="search"
            label="Digite nombre producto o palabra clave"
            single-line
            hide-details
            @input="getDataFull()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!--   dsoto 03-11-2022  -->

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>

          <v-data-table
            :headers="headers"
            :items="datosPaginados"
            :search="search"
            :page.sync="page"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
            @page-count="pageCount = $event"
            hide-actions
          >
            <template v-slot:items="props">
              <tr
                v-if="
                  (props.item.relat == 1 &&
                    superAbiertos.includes(props.item.idSuper)) ||
                  props.item.relat == 0
                "
              >
                <td
                  v-if="props.item.relat == 0"
                  class="font-weight-bold text-xs-left"
                >
                  {{ props.item.codigo }}
                </td>
                <td v-if="props.item.relat == 1" class="text-xs-left">
                  {{ props.item.codigo }}
                </td>
                <td
                  class="font-weight-bold text-uppercase"
                  v-if="props.item.relat == 0"
                >
                  {{ props.item.descripcion }}&nbsp;
                  <v-btn
                    v-if="
                      props.item.muestraFlecha &&
                      superAbiertos.includes(props.item.id)
                    "
                    outline
                    icon
                    dark
                    color="grey darken-2"
                    small
                    title="Ocultar sub items"
                    @click="handleRowClicked(props.item)"
                  >
                    <v-icon>arrow_drop_up</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      props.item.muestraFlecha &&
                      !superAbiertos.includes(props.item.id)
                    "
                    outline
                    icon
                    dark
                    color="grey darken-1"
                    small
                    title="Desplegar sub items"
                    @click="handleRowClicked(props.item)"
                  >
                    <v-icon>arrow_drop_down</v-icon>
                  </v-btn>
                </td>
                <td
                  style="padding-left: 30px !important"
                  v-if="props.item.relat == 1"
                >
                  {{ props.item.descripcion }}
                </td>
                <td class="text-xs-left" v-if="props.item.relat == 1">
                  {{ props.item.estado }}
                </td>
                <td v-if="props.item.relat == 0">&nbsp;</td>
                <td class="text-xs-left">
                  {{ props.item.fechaVencimiento }}
                </td>

                <td class="text-xs-left">{{ props.item.fechaModificacion }}</td>
                <td>
                  <v-btn
                    v-if="props.item.relat == 1"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Ver Archivos Asociados al Reporte"
                    @click="
                      viewHistoric(props.item.id, props.item.codigoEstado)
                    "
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      props.item.relat == 0 && usuarioLoggedTipe == 'PROVEEDOR' &&
                      getCodigoPerfil() !== 'LEC' && !isContratoCerrado()
                    "
                    depressed
                    tile
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Agregar Reporte"
                    @click="setDate(props.item.descripcion, props.item.codigo)"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                  <!-- para ocupar espacio y alinear botones en pantalla -->
                  <v-btn
                    v-if="
                      props.item.relat == 0 &&
                      usuarioLoggedTipe == 'ADMINISTRADOR'
                    "
                    class="invisible"
                    depressed
                    tile
                    fab
                    icon
                    small
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="props.item.relat == 0 && muestraAdministracion && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Editar título Reporte"
                    @click="
                      editarSuperProducto(
                        props.item.id,
                        props.item.codigo,
                        props.item.descripcion,
                        props.item.fechaVencimiento
                      )
                    "
                  >
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                  <!-- edicion subTitulo -->
                  <v-btn
                    v-if="props.item.relat == 1 && muestraAdministracion && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Editar Reporte"
                    @click="
                      abreEditarReporte(
                        props.item.id,
                        props.item.codigoEstado,
                        props.item.codigo,
                        props.item.fechaCreacion,
                        props.item.descripcion
                      )
                    "
                  >
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="muestraAdministracion && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="red"
                    small
                    title="Deshabilitar Reporte"
                    @click="
                      confirmDeshabilitar(
                        props.item.id,
                        props.item.codigo,
                        props.item.descripcion
                      )
                    "
                  >
                    <v-icon>clear</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <!-- LEYENDA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div v-if="usuarioLoggedTipe == 'PROVEEDOR'">
              <v-btn
                v-if="getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
              >
                <v-icon>add</v-icon> </v-btn
              >&nbsp;Agregar Reporte
            </div>
            &nbsp;&nbsp;&nbsp;
            <div v-if="usuarioLoggedTipe == 'PROVEEDOR'">
              <v-btn
                v-if="getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
              >
                <v-icon>remove_red_eye</v-icon> </v-btn
              >&nbsp;Ver Archivos del Reporte&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="muestraAdministracion">
              <v-btn
                v-if="getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>open_in_new</v-icon> </v-btn
              >&nbsp;Editar reporte&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="muestraAdministracion">
              <v-btn
                v-if=" getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                depressed
                outline
                icon
                fab
                dark
                color="red"
                small
              >
                <v-icon>clear</v-icon> </v-btn
              >&nbsp;Deshabilitar reporte
            </div>
          </v-card-actions>
          <!--  dsoto 10-11-2022 -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="cantRegistros"
              disabled
            ></v-text-field>
          </v-flex>
          <!--  dsoto 10-11-2022 -->

          <!--  dsoto 03-11-2022 -->
          <div class="text-center pt-2">
            <v-pagination
              @input="changePage(page)"
              v-model="page"
              :length="pageCount"
              :total-visible="9"
              circle
            >
            </v-pagination>
          </div>
          <!-- dsoto 03-11-2022  paginacion  -->
        </v-flex>
      </v-layout>
      <v-form ref="form" v-model="saveReport" lazy-validation>
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-flex xs10 class="mx-4">
              <v-card-title class="headline" style="font-weight: bold"
                >Ingrese los datos del reporte</v-card-title
              >
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fechaReporte"
                    :error-messages="fechaReporteErrors"
                    label="Fecha"
                    prepend-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fechaReporte"
                  no-title
                  @input="menu1 = false"
                  locale="es"
                  first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
              <v-textarea
                v-model="nombre"
                :error-messages="nombreErrors"
                label="Nombre del Sub Reporte"
                counter="300"
                maxlength="300"
                @input="$v.nombre.$touch()"
              ></v-textarea>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="indigo darken-1" flat="flat" @click="cerrarDialog"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="indigo darken-1"
                  flat="flat"
                  @click="save(codigoSave)"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-form>

      <!-- edicion subtitulo -->
      <v-form ref="form" v-model="editReport" lazy-validation>
        <v-dialog v-model="dialogEdit" max-width="500">
          <v-card>
            <v-flex xs10 class="mx-4">
              <v-card-title class="headline" style="font-weight: bold"
                >Ingrese los datos del reporte</v-card-title
              >
              <v-textarea
                v-model="descripcion"
                :error-messages="descripcionErrors"
                label="Nombre del Sub Reporte"
                counter="300"
                maxlength="300"
                @input="$v.descripcion.$touch()"
              ></v-textarea>
              <v-select
                v-model="estadoValue"
                :items="estadoSelect"
                item-text="nombre"
                item-value="code"
                :error-messages="estadoErrors"
                label="Estado"
                @input="$v.estadoValue.$touch()"
              ></v-select>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="indigo darken-1"
                  flat="flat"
                  @click="cerrarEditDialog"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="indigo darken-1"
                  flat="flat"
                  @click="editReporte()"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-form>

      <!-- confirmacion para deshabilitar un reporte -->
      <v-dialog v-model="confirmDesabilitar" max-width="500">
        <v-card>
          <v-flex xs10 class="mx-4">
            <v-card-title class="headline" style="font-weight: bold"
              >Deshabilitación Reporte</v-card-title
            >
            <v-card-text
              >¿Está seguro que desea deshabilitar este Reporte?</v-card-text
            >
            <v-card-text>Código: {{ codigoConfirm }}</v-card-text>
            <v-card-text>Descripción: {{ descripcionConfirm }}</v-card-text>
            <v-card-text style="font-weight: bold"
              >Esta acción no puede ser revertida</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="indigo darken-1"
                flat="flat"
                @click="cerrarDialogConfirm"
                >Cancelar</v-btn
              >
              <v-btn
                color="indigo darken-1"
                flat="flat"
                @click="deshabilitarProducto()"
                >Aceptar</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<style>
.invisible {
  visibility: hidden;
}
</style>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-pestana-generica",

  components: {
    Loading,
    AlertEmpty,
  },
  mixins: [validationMixin],
  props: {
    idPestana: Number,
    nombrePestana: String,
  },

  data() {
    return {
      //props.item.relat == 0 titulo, (negrita)
      //props.item.relat == 1 contenido
      search: "", // dsoto 03-11-2022
      codigoSave: "",
      nombre: "",
      menu1: false,
      fechaReporte: "",
      saveReport: "",
      //formulario edicion reporte
      menuEd: false,
      idEd: -1,
      fechaEdReporte: "",
      dateFormatted: "",
      codigoEd: "",
      descripcion: "",
      estadoValue: "",
      editReport: "",
      estadoSelect: [],
      dialogEdit: false,

      usuarioLoggedTipe: "",
      loading: false,
      dialog: false,
      alerta: false,
      confirmDesabilitar: false,
      idConfirm: 0,
      codigoConfirm: "",
      descripcionConfirm: "",
      id: "",
      rowsPerPageItems: [20],
      idContrato: "",
      headers: [
        { text: "Código", align: "left", sortable: false, value: "codigo" },
        { text: "Descripción", sortable: false, value: "descripcion" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Fecha Vencimiento", sortable: false, value: "fechaVencimiento" },
        {
          text: "Fecha Actualización",
          sortable: false,
          value: "fechaActualizacion",
        },
        { text: "Acción", sortable: false, value: "" },
      ],
      itemsProductos: [],
      superAbiertos: [],
      proceso: "",
      muestraAdministracion: false,
      // dsoto 08-11-2022
      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
    };
  },
  validations: {
    fechaReporte: { required },
    nombre: { required },
    fechaEdReporte: { required },
    descripcion: { required },
    estadoValue: { required },
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    if (this.idPestana > 0) {
      this.loadData2(this.idPestana);
    }
    if (
      this.usuarioLoggedTipe == "AGENCIA" ||
      this.usuarioLoggedTipe == "ADMINISTRADOR"
    ) {
      this.muestraAdministracion = true;
    }
  },

  mounted() {},
  watch: {
    idPestana(idPestanna) {
      this.idTabSelected = [];
      this.loadData2(idPestanna);
    },
    fechaEdReporte(val) {
      this.dateFormatted = this.formateaDate(this.fechaEdReporte);
    },
  },
  computed: {
    computedDateFormatted() {
      return this.formatoFecha(this.fechaEdReporte);
    },
    fechaReporteErrors() {
      const errors = [];
      if (!this.$v.fechaReporte.$dirty) return errors;
      !this.$v.fechaReporte.required &&
        errors.push("Debe establecer la fecha del reporte.");
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required &&
        errors.push("Debe escribir el nombre del reporte.");
      return errors;
    },
    fechaEdReporteErrors() {
      const errors = [];
      if (!this.$v.fechaEdReporte.$dirty) return errors;
      !this.$v.fechaEdReporte.required &&
        errors.push("Debe establecer la fecha del reporte.");
      return errors;
    },
    descripcionErrors() {
      const errors = [];
      if (!this.$v.descripcion.$dirty) return errors;
      !this.$v.descripcion.required &&
        errors.push("Debe escribir el nombre del reporte.");
      return errors;
    },
    estadoErrors() {
      const errors = [];
      if (!this.$v.estadoValue.$dirty) return errors;
      !this.$v.estadoValue.required &&
        errors.push("Debe seleccionar el estado del reporte.");
      return errors;
    },
  },
  methods: {
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId  && contratoCerradoConId.id == this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      return user.perfil.codigo;
    },
    formateaDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    cerrarDialog() {
      this.dialog = false;
      this.nombre = "";
      this.fechaReporte = "";
    },
    setDate(descripcion, codigo) {
      this.dialog = true;
      this.codigoSave = codigo;
      this.nombre = descripcion;
    },
    submit() {
      this.$v.$touch();
    },

    // dsoto 09-11-2022
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },

    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsProductos.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;

      if (this.search.length > 0) {
        this.datosPaginados = this.itemsProductos.slice(
          0,
          this.itemsProductos.length
        );
      } else {
        this.getDataPagina(this.page);
      }
    },
    // dsoto 09-11-2022

    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    viewHistoric(id, code) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "GridHistoricoProdReporte",
          params: { id: id, code: code, tipeView: "consulta" },
        });
      }, 1000);
    },
    save(codigo) {
      this.dialog = false;
      if (this.fechaReporte == "" || this.nombre == "") {
        window.getApp.$emit("DATOS_INCOMPLETOS");
        return;
      }
      this.loading = true;
      this.limpiaTabla();
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idContrato: idContrato,
        tipoProducto: this.idPestana,
        descripcion:
          (this.nombre != "" ? this.nombre + " - " : "") +
          this.formatoFecha(this.fechaReporte),
        codigo: codigo,
      };

      axios
        .post("/productoReporte/reporte/create", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.loadData2(this.idPestana);
          this.nombre = "";
          this.fechaReporte = "";
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log("error guardando reporte");
          } else if (error.response && error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
          this.loading = false;
          this.loadData2(this.idPestana);
          this.nombre = "";
          this.fechaReporte = "";
        });
    },

    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },

    crearSuperProducto() {
      // console.log("crearSuperProducto:");
      this.body = {
        idContrato: this.idContrato,
        codigo: this.codigo,
        tipoProducto: this.idPestana,
      };
      axios
        .post("/productoReporte/cuentaSuperProdReport", this.body)
        .then((response) => {
          var count = response.data;
          var codigo =
            (this.nombrePestana.length > 2
              ? this.nombrePestana.substring(0, 2)
              : this.nombrePestana) +
            "_" +
            ++count;
          setTimeout(() => {
            this.$router.push({
              name: "FormSuperProducto",
              params: {
                tipeView: "crear",
                titleViewCenter: "Nuevo " + this.nombrePestana,
                idContrato: this.idContrato,
                idPestana: this.idPestana,
                codigo: codigo,
              },
            });
          }, 1000);
        })
        .catch((error) => {
          if (error) {
            console.log("error contando:" + error.response);
          } else {
            console.log("error contando");
          }
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          return;
        });
    },

    editarSuperProducto(idSuperProducto, codigo, descripcion, fechaVencimiento) {
      console.log("editarSuperProducto:" + fechaVencimiento);
      setTimeout(() => {
        this.$router.push({
          name: "FormSuperProducto",
          params: {
            tipeView: "modificar",
            titleViewCenter: "Editar " + this.nombrePestana,
            idContrato: this.idContrato,
            idProducto: idSuperProducto,
            idPestana: this.idPestana,
            codigo: codigo,
            descripcion: descripcion,
            fechaVencimiento: fechaVencimiento,
          },
        });
      }, 1000);
    },

    confirmDeshabilitar(idReporte, codigo, desc) {
      this.confirmDesabilitar = true;
      this.idConfirm = idReporte;
      this.codigoConfirm = codigo;
      this.descripcionConfirm = desc;
    },

    cerrarDialogConfirm() {
      this.confirmDesabilitar = false;
      this.idConfirm = 0;
      this.codigoConfirm = "";
      this.descripcionConfirm = "";
    },
    deshabilitarProducto() {
      this.loading = true;
      this.confirmDesabilitar = false;
      this.body = {
        id: this.idConfirm,
        idContrato: this.idContrato,
        codigo: this.codigo,
        tipoProducto: this.idPestana,
        idUserLogged: this.$store.getters.userLogged.id,
        subProceso: this.$store.getters.subProTabSelectedStored,
      };
      axios
        .post("/productoReporte/deshabilita", this.body)
        .then((response) => {
          window.getApp.$emit("APP_SAVE");
          this.loadData2(this.idPestana);
          this.loading = false;
        })
        .catch((error) => {
          if (error) {
            console.log("error deshabilitarProducto:" + error.response);
          } else {
            console.log("error deshabilitarProducto");
          }
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          this.loading = false;
        });
    },

    async loadPestanaFilter2(idPestanna) {
      //alert(idPestanna + " loadPestanaFilter2");

      if (idPestanna <= 0) return [];

      this.body = {
        idContrato: this.$store.getters.contratoStored,
        proceso: this.$store.getters.proSelectedStored,
        tipoProducto: idPestanna,
      };

      return await axios
        .post("/productoReporte/findFilters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error);
          } else {
            console.log("Error cargando pestanas genericas");
          }
          return [];
        });
    },

    limpiaTabla() {
      this.itemsProductos = [];
      this.datosPaginados = [];
      this.cantRegistros = 0;
      this.pageCount = 0;
      this.page = 1;
    },

    async loadData2(idPestanna) {
      this.limpiaTabla();
      this.alerta = false;

      this.loading = true;

      this.itemsProductos = await this.loadPestanaFilter2(idPestanna);

      // alert(this.itemsProductos.length + " LD2");

      if (this.itemsProductos.length == 0) {
        this.alerta = true;
      } else {
        var idSuper = -1;
        var nItems = this.itemsProductos.length;

        for (var i = 0; i < nItems; i++) {
          this.$set(this.itemsProductos[i], "_showDetails", true);
          if (this.itemsProductos[i].relat == false) {
            //titulo/superProd/categoria padre
            this.superAbiertos.push(this.itemsProductos[i].id);
            idSuper = this.itemsProductos[i].id;
            this.$set(this.itemsProductos[i], "idSuper", -1);

            if (i < nItems - 1 && this.itemsProductos[i + 1].relat == true) {
              //tiene al menos un hijo/subTitulo
              this.$set(this.itemsProductos[i], "muestraFlecha", true);
            } else {
              //NO tiene hijos/subTitulos
              this.$set(this.itemsProductos[i], "muestraFlecha", false);
            }
          } else {
            //subtitulo/elemento hijo
            this.$set(this.itemsProductos[i], "idSuper", idSuper);
            this.$set(this.itemsProductos[i], "muestraFlecha", false);
          }
        }

        this.cantRegistros = this.itemsProductos.length;
        this.pageCount = Math.ceil(
          this.itemsProductos.length / this.rowsPerPageItems
        ); // dsoto 09-11-2022
        this.getDataPagina(this.page); // dsoto 09-11-2022
        this.alerta = false;
      }
      this.loading = false;
    },
    handleRowClicked(item) {
      if (item.relat == true) {
        //solo para titulo/superProducto/categoriaPadre
        return;
      }

      const index = this.superAbiertos.indexOf(item.id);
      if (index > -1) {
        //cierra
        this.superAbiertos.splice(index, 1);

        for (var i = 0; i < this.datosPaginados.length; i++) {
          if (this.datosPaginados[i].idSuper == item.id) {
            this.$set(this.datosPaginados[i], "_showDetails", false);
          }
        }
      } else {
        //abre
        this.superAbiertos.push(item.id);
        for (var i = 0; i < this.datosPaginados.length; i++) {
          if (this.datosPaginados[i].idSuper == item.id) {
            this.$set(this.datosPaginados[i], "_showDetails", true);
          }
        }
      }
    },
    abreEditarReporte(id, estado, codigo, fechaCreacion, descripcion) {
      axios
        .get("/productoReporte/estadosAdmin/" + this.idContrato)
        .then((response) => {
          let est = [];
          response.data.forEach(function (e) {
            est.push({
              nombre: e.descripcion,
              code: e.id,
            });
          });
          this.estadoSelect = est;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          return;
        });

      this.idEd = id;
      (this.codigoEd = codigo), (this.descripcion = descripcion);
      this.fechaEdReporte = this.parseDate(fechaCreacion.split(" ")[0]);
      this.estadoValue = estado;
      this.dialogEdit = true;
    },

    cerrarEditDialog() {
      this.dialogEdit = false;
      this.idEd = -1;
      this.descripcion = "";
      this.fechaEdReporte = "";
      this.estadoValue = "";
      this.editReport = "";
    },
    editReporte() {
      this.dialogEdit = false;
      if (
        this.fechaEdReporte == "" ||
        this.descripcion == "" ||
        this.estadoValue == ""
      ) {
        window.getApp.$emit("DATOS_INCOMPLETOS");
        return;
      }
      this.loading = true;
      this.limpiaTabla();
      this.$v.$touch();

      this.body = {
        idContrato: this.$store.getters.contratoStored,
        id: this.idEd,
        fechaCreacion: this.formateaDate(this.fechaEdReporte) + " 00:00:00",
        estadoProducto: this.estadoValue,
        descripcion: this.descripcion,
      };

      axios
        .post("/productoReporte/guardaSubProdReport", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.loadData2(this.idPestana);

          this.cerrarEditDialog();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log("error editando reporte");
          } else if (error.response && error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
          this.loading = false;
          this.loadData2(this.idPestana);

          this.cerrarEditDialog();
        });
    },
  },
};
</script>